import axios from 'axios';
import Cookies from 'js-cookie';

const BASE_URL = process.env.REACT_APP_BASE_URL || 'http://localhost:8080/ERP/rest';

console.log('Axios: Base URL configured as:', BASE_URL);

const instance = axios.create({
  baseURL: BASE_URL,
  timeout: 15000,
  withCredentials: false, // Set to false initially, can be overridden per request
});

// Request interceptor
instance.interceptors.request.use(
  (config) => {
    console.log('Axios: Request interceptor triggered');
    console.log('Axios: Request URL:', config.url);
    console.log('Axios: Request method:', config.method);
    console.log('Axios: Request data:', config.data);
    
    // Only add token for authenticated endpoints (not login)
    const token = Cookies.get('token');
    const isLoginRequest = config.url && (
      config.url.includes('/login') || 
      config.url.includes('doLogin')
    );
    
    if (token && !isLoginRequest) {
      console.log('Axios: Adding token to request:', token.substring(0, 20) + '...');
      config.headers.Authorization = `Bearer ${token}`;
    } else if (isLoginRequest) {
      console.log('Axios: Login request detected, not adding token');
      // Ensure no auth header is set for login requests
      delete config.headers.Authorization;
    }
    
    // Ensure proper headers
    if (!config.headers['Content-Type']) {
      config.headers['Content-Type'] = 'application/json';
    }
    
    config.headers['Accept'] = 'application/json';
    
    console.log('Axios: Final request headers:', config.headers);
    
    return config;
  },
  (error) => {
    console.error('Axios: Request interceptor error:', error);
    return Promise.reject(error);
  }
);

// Response interceptor
instance.interceptors.response.use(
  (response) => {
    console.log('Axios: Response interceptor - success');
    console.log('Axios: Response status:', response.status);
    console.log('Axios: Response data:', response.data);
    return response;
  },
  (error) => {
    console.error('Axios: Response interceptor - error');
    console.error('Axios: Error status:', error.response?.status);
    console.error('Axios: Error data:', error.response?.data);
    console.error('Axios: Error config:', error.config);
    
    // Handle token expiration
    if (error.response?.status === 401) {
      const isLoginRequest = error.config?.url && (
        error.config.url.includes('/login') || 
        error.config.url.includes('doLogin')
      );
      
      if (!isLoginRequest) {
        console.log('Axios: 401 on authenticated request, clearing token');
        // Clear token if 401 on authenticated request
        Cookies.remove('token');
        localStorage.removeItem('user');
        
        // Redirect to login if not already there
        if (window.location.pathname !== '/login') {
          window.location.href = '/login';
        }
      }
    }
    
    return Promise.reject(error);
  }
);

export default instance;